/**
 * @generated SignedSource<<58d6c7d1691df37e2da3249fd48b55b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteTaskSetInput = {
  id: string;
  globalProjectId: string;
  globalTaskIds?: ReadonlyArray<string> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteTaskSetMutation$variables = {
  input: DeleteTaskSetInput;
};
export type deleteTaskSetMutation$data = {
  readonly deleteTaskSet: {
    readonly deletedTaskSetId: string | null;
    readonly deletedTaskIds: ReadonlyArray<string | null> | null;
    readonly project: {
      readonly id: string;
    } | null;
  } | null;
};
export type deleteTaskSetMutation = {
  variables: deleteTaskSetMutation$variables;
  response: deleteTaskSetMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTaskSetPayload",
    "kind": "LinkedField",
    "name": "deleteTaskSet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTaskSetId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTaskIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteTaskSetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteTaskSetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bb0a6dc7b86f5accc0bcd076a37884fa",
    "id": null,
    "metadata": {},
    "name": "deleteTaskSetMutation",
    "operationKind": "mutation",
    "text": "mutation deleteTaskSetMutation(\n  $input: DeleteTaskSetInput!\n) {\n  deleteTaskSet(input: $input) {\n    deletedTaskSetId\n    deletedTaskIds\n    project {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c281d50e6249f2dea8e029af1915644";

export default node;
